export default "__VITE_ASSET__BBNPUvnB__"